import { createFileRoute } from "@tanstack/react-router";
import { SERVICES_FAQS_ES } from "@/lib/services-faqs";
import { alternatePath } from "@/lib/i18n";
import { breadcrumbJsonLd, faqJsonLd, serviceJsonLd, webPageJsonLd } from "@/lib/seo";
import { buildCorporateHead } from "@/lib/corporate-seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

export const Route = createFileRoute("/es/servicios")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildCorporateHead({
    locale: "es",
    title: "Servicios Shopify en México: Desarrollo, SEO, CRO y Plus | Shugert",
    description:
      "Servicios Shopify en México para marcas establecidas: desarrollo, Shopify Plus, migraciones, SEO técnico, CRO, rendimiento, integraciones e ingeniería continua.",
    path: "/es/servicios",
    altPath: alternatePath("/es/servicios", "en"),
    jsonLd: [
      breadcrumbJsonLd([{ name: "Inicio", path: "/es" }, { name: "Servicios Shopify", path: "/es/servicios" }]),
      faqJsonLd(SERVICES_FAQS_ES),
      serviceJsonLd({
        name: "Servicios Shopify en México",
        description:
          "Intervenciones Shopify senior para equipos en México y Latinoamérica: rendimiento, conversión, SEO técnico, desarrollo, migraciones, aplicaciones, integraciones, analítica, ingeniería continua y Shopify Plus.",
        path: "/es/servicios",
        serviceType: "Servicios de Ingeniería Shopify",
        locale: "es",
      }),
      webPageJsonLd({
        name: "Servicios Shopify en México para Marcas Establecidas",
        path: "/es/servicios",
        description:
          "Centro de decisión para equipos en México que necesitan elegir entre desarrollo Shopify, Plus, migración, rendimiento, CRO, SEO técnico e integraciones según la restricción real del negocio.",
        inLanguage: "es-MX",
      }),
    ],
  }),
});
